import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import {
  spacing,
  fontSize,
  fontWeight,
  colors,
  Text,
  TextButton,
} from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/aggregate-store-performance/utils/domain/intl'
import Store from 'domains/aggregate-store-performance/assets/Store.svg'

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: colors.GRAYSCALE.X50,
})

const StoreImage = styled.img({
  filter: 'opacity(0.5)',
  maxWidth: '325px',
})

const TextContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: `${spacing.X24} 0`,
})

const StyledTextButton = styled(TextButton)({
  border: 'none',
  fontSize: fontSize.X18,
  fontWeight: fontWeight.SEMIBOLD,
})

interface FiltersEmptyStateProps {
  onEditFiltersClicked: () => void
  hasSelectedFilters: boolean
}

export const FiltersEmptyState: FunctionComponent<FiltersEmptyStateProps> = ({
  onEditFiltersClicked,
  hasSelectedFilters,
}) => {
  const messages = useDomainMessages({
    title: 'aggregateStorePerformanceDomain.filtersEmptyState.title',
    content: 'aggregateStorePerformanceDomain.filtersEmptyState.content',
    editButton: 'aggregateStorePerformanceDomain.filtersEmptyState.edit',
  })

  return (
    <Container>
      <StoreImage src={Store} />
      <TextContainer>
        <Text weight="semibold" size="large">
          {messages.title}
        </Text>
        <Text weight="regular" size="medium">
          {messages.content}
        </Text>
      </TextContainer>
      {hasSelectedFilters && (
        <StyledTextButton onClick={onEditFiltersClicked}>{messages.editButton}</StyledTextButton>
      )}
    </Container>
  )
}
